import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, InstagramIcon, MailIcon, MapPinIcon, PhoneIcon, GlobeIcon } from 'lucide-react';
import { nav, site } from '../data/site';
import { solutions } from '../data/solutions';
export function Footer() {
  return <footer className="border-t border-line bg-ink text-white" data-id="element-28" data-mp="32m1ch24t96q7">
      <div className="mx-auto grid max-w-content gap-12 px-6 py-16 md:grid-cols-2 lg:grid-cols-4" data-id="element-29" data-mp="36pzatambadi7">
        <div data-id="element-30" data-mp="3ufjww2drhqvp">
          <img src={site.logo} alt="Logo Goelst France" className="mb-6 h-10 w-auto bg-white p-1" width={220} height={64} data-id="element-31" data-mp="3uftpzyu3se5m" />
          <p className="max-w-xs text-[15px] leading-relaxed text-white/70" data-id="element-32" data-mp="3le2katzkc7br">
            Rails à rideaux manuels, électriques, motorisés et sur mesure pour les projets d’architecture,
            d’hôtellerie, de santé et de résidentiel haut de gamme.
          </p>
          <a href={site.instagram} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 text-[15px] text-white/70 transition-colors duration-150 ease-smooth hover:text-white" data-id="element-33" data-mp="2ezbbm4477i76">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-34" data-mp="3v7gg42ez4eac" />
            Instagram
          </a>
        </div>

        <nav aria-label="Pages du site" data-id="element-35" data-mp="3q8djn6d27gdz">
          <h2 className="mb-5 text-[13px] font-semibold uppercase tracking-[0.16em] text-white/50" data-id="element-36" data-mp="3q7bxa5qlf7gy">Navigation</h2>
          <ul className="space-y-3 text-[15px]" data-id="element-37" data-mp="80ns6fvjmkba">
            {nav.map(item => <li key={item.to} data-id="element-38" data-mp="33no2ai97rmt">
                <Link to={item.to} className="text-white/80 transition-colors duration-150 ease-smooth hover:text-signal" data-id="element-39" data-mp="hsk3wtqjy8xz">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <nav aria-label="Solutions de rails à rideaux" data-id="element-40" data-mp="mrwpzc9lnbzi">
          <h2 className="mb-5 text-[13px] font-semibold uppercase tracking-[0.16em] text-white/50" data-id="element-41" data-mp="mthk50s04swu">Solutions</h2>
          <ul className="space-y-3 text-[15px]" data-id="element-42" data-mp="twxsxe84bibf">
            {solutions.map(s => <li key={s.slug} data-id="element-43" data-mp="yupk260xv0ek">
                <Link to={`/solutions#${s.slug}`} className="text-white/80 transition-colors duration-150 ease-smooth hover:text-signal" data-id="element-44" data-mp="yruyuca3pbk3">
                  {s.title}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-45" data-mp="1hkp60k1hfzdr">
          <h2 className="mb-5 text-[13px] font-semibold uppercase tracking-[0.16em] text-white/50" data-id="element-46" data-mp="1hkff8u8m5o70">Coordonnées</h2>
          <ul className="space-y-4 text-[15px] text-white/80" data-id="element-47" data-mp="1mjikaeolfuez">
            <li className="flex gap-3" data-id="element-48" data-mp="1mhxs2vpr4nka">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-signal" aria-hidden="true" data-id="element-49" data-mp="1rj4vkikv30l5" />
              <address className="not-italic leading-relaxed" data-id="element-50" data-mp="3obx1fbjbcuuc">
                {site.address.street}
                <br data-id="element-51" data-mp="3t9gggdnu5bnc" />
                {site.address.city}, {site.address.region} {site.address.postalCode}
                <br data-id="element-52" data-mp="2ag5dkmdud4ej" />
                {site.address.country}
              </address>
            </li>
            <li className="flex gap-3" data-id="element-53" data-mp="25nc97zmaby2z">
              <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-signal" aria-hidden="true" data-id="element-54" data-mp="25maqd8z127ap" />
              <a className="transition-colors duration-150 ease-smooth hover:text-white" href={site.phoneHref} data-id="element-55" data-mp="21kpg7vdvo747">
                {site.phoneDisplay}
              </a>
            </li>
            <li className="flex gap-3" data-id="element-56" data-mp="2tdg3vhhhwnhu">
              <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-signal" aria-hidden="true" data-id="element-57" data-mp="2pcea3g6cl3n9" />
              <a className="transition-colors duration-150 ease-smooth hover:text-white" href={site.emailHref} data-id="element-58" data-mp="2kdb6m060n5he">
                {site.email}
              </a>
            </li>
            <li className="flex gap-3" data-id="element-59" data-mp="2fdyh17nrfkb4">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-signal" aria-hidden="true" data-id="element-60" data-mp="18ynubc5v8qxs" />
              <a className="transition-colors duration-150 ease-smooth hover:text-white" href={site.website} target="_blank" rel="noopener noreferrer" data-id="element-61" data-mp="13zb88tmtjnw9">
                goelst-international.com
              </a>
            </li>
            <li className="flex gap-3" data-id="element-62" data-mp="2ivky65amialz">
              <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-signal" aria-hidden="true" data-id="element-63" data-mp="2iwmccimxrd7x" />
              <span className="leading-relaxed" data-id="element-64" data-mp="2nunsovsz8yfp">
                Lun – Ven : 09:00 – 18:00
                <br data-id="element-65" data-mp="3bl1nuv6uzdei" />
                Samedi et dimanche : fermé
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-66" data-mp="3fizbhtkzdrfs">
        <div className="mx-auto flex max-w-content flex-col gap-2 px-6 py-6 text-[13px] text-white/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-67" data-mp="31khj3ik4rqrj">
          <p data-id="element-68" data-mp="36mgiyignw5jq">© {new Date().getFullYear()} {site.name} — Rails à rideaux. Tous droits réservés.</p>
          <p data-id="element-69" data-mp="1q8qf9ctgfjam">Qualité et design européens depuis {site.since}.</p>
        </div>
      </div>
    </footer>;
}